import axios from 'axios'
import { useCallback, useEffect, useState } from 'react'

import { AddressApiResponse } from '../../common/addressTypes'
import { AsyncState } from '../../redux/fetchAction'
import { useAppSelector } from '../../redux/hooks'

export const useFetchAddressDetail = (addressId?: string | number) => {
  const { token } = useAppSelector(state => state.myProfile)

  const [state, setState] = useState<AsyncState<AddressApiResponse>>({
    fetching: true,
    data: null,
    error: false,
  })

  const fetchAddressDetail = useCallback(async () => {
    if (!addressId || !token) {
      setState({
        fetching: false,
        data: null,
        error: true,
      })
      return
    }

    setState({
      fetching: true,
      data: null,
      error: false,
    })

    try {
      const response = await axios.get<AddressApiResponse>(
        `https://data.regesta.cz/DrmApi/api/v1.0/Adresy/${addressId}?access_token=${token}`
      )
      setState({
        fetching: false,
        data: response.data,
        error: false,
      })
    } catch (error) {
      setState({
        fetching: false,
        data: null,
        error: true,
      })
    }
  }, [addressId, token])

  useEffect(() => {
    fetchAddressDetail()
  }, [fetchAddressDetail])

  return state
}
